import { useState, useEffect, useRef } from 'react'

export const useCountdown = ({
  seconds,
  active,
  isLeader,
  onComplete,
  onTick,
}) => {
  const [remaining, setRemaining] = useState(seconds)

  const intervalRef = useRef(null)

  const setRemoteTick = (value) => {
    setRemaining(value)
  }

  useEffect(() => {
    if (!active) {
      clearInterval(intervalRef.current)
      setRemaining(seconds)
      return
    }
    if (!isLeader) return

    setRemaining(seconds)

    intervalRef.current = setInterval(() => {
      setRemaining((prev) => {
        const next = prev - 1
        onTick?.(next)
        if (next <= 0) {
          clearInterval(intervalRef.current)
          onComplete?.()
          return 0
        }
        return next
      })
    }, 1000)

    return () => clearInterval(intervalRef.current)
  }, [active, isLeader])

  return { remaining, setRemoteTick }
}

